import React from 'react';
import AlertStandard from './AlertStandard';
import AlertBanner from './AlertBanner';

export interface AlertProps {
  variant: 'standard' | 'banner';
  children?: React.ReactNode;
  headline?: string;
  subtitle?: string;
  renderImage?: () => React.ReactNode;
  isDismissible?: boolean;
  onDismiss?: () => void;
  bg?: string;
}

const variants = {
  standard: AlertStandard,
  banner: AlertBanner,
};

const Alert = ({ variant, children, ...props }: AlertProps) =>
  React.createElement(variants[variant], props, children);

export default Alert;
